<template>
    <div class="azul--text">
        <h2 class="text-center py-7 my-7">
            Ingrese para ver nuestros productos y ofertas
        </h2>
        <CardForm
            style="max-width: 400px; margin: auto;"
            class="my-5"
            @submit="submit"
        >
            <template slot="header">
                <h3 class="azul--text">
                    Acceder
                </h3>
            </template>
            <template
                v-slot:default="{
                    rules
                }"
            >
                <v-text-field
                    v-model.lazy="username"
                    label="Usuario"
                    name="username"
                    required
                    type="text"
                    :rules="[rules.required()]"
                    :readonly="loading"
                />
                <v-text-field
                    v-model.lazy="password"
                    label="Contraseña"
                    name="password"
                    required
                    :type="showPass ? 'text' : 'password'"
                    :rules="[rules.required()]"
                    :readonly="loading"
                />
                <!-- <v-flex xs12 my-1>
        <a :disabled="loading" href="#/forget-password">Recuperar contraseña</a>
      </v-flex> -->
            </template>
            <template slot="message">
                <p v-show="error" class="error--text show-error">
                    {{ error }}
                </p>
            </template>
            <template slot="actions">
                <v-btn
                    :disabled="loading"
                    :loading="loading"
                    color="azul"
                    class="white--text"
                    type="submit"
                >
                    Iniciar Sesión
                </v-btn>
            </template>
        </CardForm>
        <a href="/contact">
            <h3 id="createacc" class="text-center py-7 my-7 azul--text">
                ¿ Quiere crear una cuenta ?
            </h3>
        </a>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import CardForm from '../components/CardForm';

export default {
    components: { CardForm },
    data: () => ({
        error: null,
        showPass: false,
        password: '',
        username: ''
    }),
    computed: {
        ...mapState('auth', ['loading']),
        ...mapGetters(['isLoggedIn'])
    },
    methods: {
        ...mapActions('auth', ['signIn']),

        async submit(formValid) {
            this.error = null;
            if (!formValid || this.loading) {
                return;
            }

            const { error } = await this.signIn({
                username: this.username,
                password: this.password
            });
            if (this.isLoggedIn) {
                this.$router.replace({
                    name: 'Home'
                });
            } else {
                this.error = error; // ||"Usuario o Contraseña incorrecto.";
            }
        }
    }
};
</script>

<style scoped>
p.error--text.show-error {
    text-align: center;
    margin-bottom: 0;
}
#createacc {
    text-decoration: none;
}
</style>
